/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Fairuse_Section3list_Amount2Inputs */

const id_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah dan Substansialitas:`)
};

const ms_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah dan Substansialiti:`)
};

const da_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mængde og Væsentlighed:`)
};

const de_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umfang und Wesentlichkeit:`)
};

const en_us2_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount and Substantiality:`)
};

const es_es2_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cantidad y sustancialidad:`)
};

const es_mx2_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cantidad y sustancialidad:`)
};

const fil_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dami at Kabuuan:`)
};

const fr_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantité et importance :`)
};

const it_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantità e sostanzialità:`)
};

const hu_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mennyiség és lényegesség:`)
};

const nl_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveelheid en substantie:`)
};

const no_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengde og vesentlighet:`)
};

const pl_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilość i istotność:`)
};

const pt_br2_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantidade e Substancialidade:`)
};

const pt_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantidade e substancialidade:`)
};

const ro_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cantitatea și substanțialitatea:`)
};

const fi_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Määrä ja olennaisuus:`)
};

const sv_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mängd och väsentlighet:`)
};

const vi_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng và tính trọng yếu:`)
};

const tr_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miktar ve Önem:`)
};

const cs_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Množství a podstatnost:`)
};

const bg_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Количество и същественост:`)
};

const ru_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объём и существенность:`)
};

const uk_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обсяг та суттєвість:`)
};

const ar_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الكمية والجوهرية:`)
};

const hi_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मात्रा:`)
};

const th_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปริมาณและสาระสำคัญ:`)
};

const ja_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`量と実質性：`)
};

const zh_cn2_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用的数量和实质性：`)
};

const zh_hant1_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用的數量和實質性：`)
};

const ko_misc_fairuse_section3list_amount2 = /** @type {(inputs: Misc_Fairuse_Section3list_Amount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용량 및 실질성:`)
};

/**
* | output |
* | --- |
* | "Amount and Substantiality:" |
*
* @param {Misc_Fairuse_Section3list_Amount2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_fairuse_section3list_amount2 = /** @type {((inputs?: Misc_Fairuse_Section3list_Amount2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Fairuse_Section3list_Amount2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_fairuse_section3list_amount2(inputs)
	if (locale === "ms") return ms_misc_fairuse_section3list_amount2(inputs)
	if (locale === "da") return da_misc_fairuse_section3list_amount2(inputs)
	if (locale === "de") return de_misc_fairuse_section3list_amount2(inputs)
	if (locale === "en-US") return en_us2_misc_fairuse_section3list_amount2(inputs)
	if (locale === "es-ES") return es_es2_misc_fairuse_section3list_amount2(inputs)
	if (locale === "es-MX") return es_mx2_misc_fairuse_section3list_amount2(inputs)
	if (locale === "fil") return fil_misc_fairuse_section3list_amount2(inputs)
	if (locale === "fr") return fr_misc_fairuse_section3list_amount2(inputs)
	if (locale === "it") return it_misc_fairuse_section3list_amount2(inputs)
	if (locale === "hu") return hu_misc_fairuse_section3list_amount2(inputs)
	if (locale === "nl") return nl_misc_fairuse_section3list_amount2(inputs)
	if (locale === "no") return no_misc_fairuse_section3list_amount2(inputs)
	if (locale === "pl") return pl_misc_fairuse_section3list_amount2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_fairuse_section3list_amount2(inputs)
	if (locale === "pt") return pt_misc_fairuse_section3list_amount2(inputs)
	if (locale === "ro") return ro_misc_fairuse_section3list_amount2(inputs)
	if (locale === "fi") return fi_misc_fairuse_section3list_amount2(inputs)
	if (locale === "sv") return sv_misc_fairuse_section3list_amount2(inputs)
	if (locale === "vi") return vi_misc_fairuse_section3list_amount2(inputs)
	if (locale === "tr") return tr_misc_fairuse_section3list_amount2(inputs)
	if (locale === "cs") return cs_misc_fairuse_section3list_amount2(inputs)
	if (locale === "bg") return bg_misc_fairuse_section3list_amount2(inputs)
	if (locale === "ru") return ru_misc_fairuse_section3list_amount2(inputs)
	if (locale === "uk") return uk_misc_fairuse_section3list_amount2(inputs)
	if (locale === "ar") return ar_misc_fairuse_section3list_amount2(inputs)
	if (locale === "hi") return hi_misc_fairuse_section3list_amount2(inputs)
	if (locale === "th") return th_misc_fairuse_section3list_amount2(inputs)
	if (locale === "ja") return ja_misc_fairuse_section3list_amount2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_fairuse_section3list_amount2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_fairuse_section3list_amount2(inputs)
	return ko_misc_fairuse_section3list_amount2(inputs)
});
export { misc_fairuse_section3list_amount2 as "misc.fairUse.section3List.amount" }